import type { AnchorHTMLAttributes, ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import type { IconName } from '../Icon/types'
import { cx } from '../utils/cx'
import type { ButtonVariant } from './types'
import './Button.css'

export interface ButtonLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'children'> {
  variant?: ButtonVariant
  icon?: IconName
  children: ReactNode
  fullWidth?: boolean
  size?: 'default' | 'large'
}

/** Enlace con aspecto de botón (tel:, mailto:, wa.me, Maps, descargas). Misma hoja de estilos que Button. */
export function ButtonLink({ variant = 'primary', icon, children, fullWidth = true, size = 'default', className, ...rest }: ButtonLinkProps) {
  return (
    <a
      className={cx('hp-button', `hp-button--${variant}`, size === 'large' && 'hp-button--large', fullWidth && 'hp-button--full', className)}
      {...rest}
    >
      {icon && <Icon name={icon} size={size === 'large' ? 32 : 20} />}
      <span className="hp-button__label">{children}</span>
    </a>
  )
}
